import environment from "../environment";
import io from "socket.io-client";

const socketModel = io(environment.chat_api, {
  auth: (cb) => {
    const token =
      typeof window !== "undefined"
        ? localStorage.getItem("token") || sessionStorage.getItem("token")
        : null;
    cb({ token: token || "" });
  },
  autoConnect: true,
});
export default socketModel;
